// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ebdc71c6","239":"7c3e3c37","455":"45b1ad5d"}[chunkId] + ".chunk.js";
};